<h1 mat-dialog-title>
  <app-titulo-paginas titulo="Medição (Capa de Lote)"></app-titulo-paginas>
</h1>
<mat-dialog-content>
  <div class="col-lg-12">
    <div class="alert alert-info">
      <div class="card-header">
        <span class="fas fa-user"></span><strong> Paciente: </strong>{{
        data?.ordemservico?.orcamento?.homecare?.paciente?.pessoa?.nome
        | titlecase
        }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label for="profissional">Profissional:</label>
        <p>{{ data?.profissional?.pessoa?.nome }}</p>
      </div>
      <div class="col-md-4">
        <label for="dataSolicitacao">Data de Solicitação:</label>
        <p>{{ data?.dataSolicitacao }}</p>
      </div>
      <div class="col-md-4">
        <label for="numeroGuiaPrestador">Número Guia Prestador:</label>
        <p>{{ data?.numeroGuiaPrestador }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <label for="obs">Observação</label>
        <p>{{ data?.observacao }}</p>
      </div>
    </div>
    <div class="table-responsive-vertical">
      <table class="table table-bordered" id="table">
        <thead>
          <tr>
            <th>Especialidade</th>
            <th style="width: 15%">Qtd Sessão</th>
            <th style="width: 15%">Qtd Atendida</th>
            <th class="col-lg-3" *ngIf="!usuario.user.pessoa.cliente">
              Data Execução
            </th>
            <th *ngIf="!usuario.user.pessoa.cliente">Hora Inicio</th>
            <th *ngIf="!usuario.user.pessoa.cliente">Hora Fim</th>
            <th *ngIf="!usuario.user.pessoa.cliente">Redução/Acrescimo</th>
            <th style="width: 15%">Valor Unitário</th>
            <th>Valor Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data?.medicao_servicos">
            <td data-title="Serviço">
              {{ item.servico?.descricao | titlecase }}
            </td>
            <td data-title="Qtd Sessão">{{ item.quantidade }}</td>
            <td data-title="Qtd Atendida">{{ item.atendido }}</td>
            <td data-title="Data Execução" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.dataExecucao }}
            </td>
            <td data-title="Hora Início" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.horaInicial }}
            </td>
            <td data-title="Hora Fim" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.horaFinal }}
            </td>
            <td data-title="Redução/Acrescimo" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.reducaoAcrescimo }}
            </td>
            <td data-title="Valor Unitário">
              {{ item.valor | currency : 'BRL' }}
            </td>
            <td data-title="Valor Total">
              {{ item.subtotal | currency : 'BRL' }}
            </td>
          </tr>
          <tr *ngFor="let item of data?.medicao_produtos">
            <td data-title="Produto">
              {{ item.produto?.descricao | titlecase }}
            </td>
            <td data-title="Qtd Sessão">{{ item.quantidade }}</td>
            <td data-title="Qtd Atendida">{{ item.atendido }}</td>
            <td data-title="Data Execução" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.dataExecucao }}
            </td>
            <td data-title="Hora Início" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.horaInicial }}
            </td>
            <td data-title="Hora Fim" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.horaFinal }}
            </td>
            <td data-title="Redução/Acrescimo" *ngIf="!usuario.user.pessoa.cliente">
              {{ item.reducaoAcrescimo }}
            </td>
            <td data-title="Valor Unitário">
              {{ item.valor | currency : 'BRL' }}
            </td>
            <td data-title="Valor Total">
              {{ item.subtotal | currency : 'BRL' }}
            </td>
          </tr>
          <tr>
            <td>Adicional: {{ data.adicional | currency : 'BRL' }}</td>
            <td colspan="2">
              Desconto: {{ data.desconto | currency : 'BRL' }}
            </td>
            <td colspan="2" data-title="TOTAL" class="info">
              TOTAL: {{ data.valor | currency : 'BRL' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-comentariosmedicao [medicao]="data"></app-comentariosmedicao>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button type="button" class="btn btn-warning" (click)="gerarContaPagar()">Gerar Conta a Pagar</button> -->
  <button type="button" class="btn btn-secondary rounded-pill mr-2" (click)="dialogRef.close()">
    Fechar
  </button>
  <button type="button" (click)="downloadPdf()" class="btn btn-warning rounded-pill">
    Exportar PDF
  </button>
</mat-dialog-actions>
